import { StaticPagesRes } from '@type/buzzkuri/static-page'
import { ErrorStatus } from '@type/common'
import { useMemo } from 'react'

export const useStaticPagesRes = (
  props: StaticPagesRes | ErrorStatus
): StaticPagesRes => {
  // error発生時には静的部分のみ表示を表示する
  const staticPagesRes: StaticPagesRes = useMemo(
    () =>
      'errorStatus' in props
        ? {
            metaData: {},
            pageContent: {},
            business: {},
          }
        : (props as StaticPagesRes),
    [props]
  )
  return staticPagesRes
}
